import React from 'react';

const OtpSentIcon = () => {
  return (
    <svg className='iconTop' width='120' height='120' viewBox='0 0 120 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M80.393 41.084V19.713a7.5 7.5 0 0 0-7.5-7.5H28.159a7.5 7.5 0 0 0-7.5 7.5v80.574a7.5 7.5 0 0 0 7.5 7.5H72.893a7.5 7.5 0 0 0 7.5-7.5V86.734'
        stroke='#000'
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <rect x='56.499' y='25.156' width='11.947' height='4.38' rx='2.19' transform='rotate(-180 56.499 25.156)' fill='var(--theme-primary, #810ea9)' />
      <path
        d='M90.846 48.691H47.103a7 7 0 0 0-7 7v16.578a7 7 0 0 0 7 7h1.827a2 2 0 0 1 2 2v5.623c0 1.442 1.793 2.164 2.841 1.144l8.435-8.2a2 2 0 0 1 1.394-.567h27.246a7 7 0 0 0 7-7V55.691a7 7 0 0 0-7-7z'
        stroke='#000'
        strokeWidth='2.5'
      />
      <path
        d='M56.865 63.554c-2.963.697-3.485 1.261-4.127 4.47-.644-3.21-1.164-3.774-4.128-4.47 2.963-.697 3.484-1.26 4.127-4.471.643 3.21 1.164 3.775 4.127 4.47zM73.12 63.554c-2.963.697-3.485 1.261-4.127 4.47-.644-3.21-1.165-3.774-4.128-4.47 2.963-.697 3.484-1.26 4.127-4.471.643 3.21 1.164 3.775 4.127 4.47zM89.374 63.554c-2.963.697-3.485 1.261-4.128 4.47-.643-3.21-1.164-3.774-4.127-4.47 2.963-.697 3.484-1.26 4.127-4.471.643 3.21 1.164 3.775 4.127 4.47z'
        fill='var(--theme-primary, #810ea9)'
        stroke='var(--theme-primary, #810ea9)'
        strokeWidth='.75'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default OtpSentIcon;
